import { ethers } from "ethers";
import { networks } from "../initAppkit"

export function formatUnits(value: bigint, decimals: number, unit: number = 8) {
  const formatted = ethers.formatUnits(value, decimals || 18);

  const [intPart, decimalPart = ""] = formatted.split(".")

  if (unit === 0) return intPart

  const slicedDecimal = decimalPart.slice(0, unit);
  const trimmedDecimal = slicedDecimal.replace(/0+$/, "");
  return trimmedDecimal ? `${intPart}.${trimmedDecimal}` : intPart;
}

export function parseUnits(value: string, decimals: number) {
  return ethers.parseUnits(value, decimals)
}

export function numberUnits(value: number, unit?: number) {
  if (!value) return "0"
  const [intPart, decimalPart = ""] = value.toString().split(".")
  if (unit === 0) return intPart
  const slicedDecimal = decimalPart.slice(0, unit);
  const trimmedDecimal = slicedDecimal.replace(/0+$/, "");
  return trimmedDecimal ? `${intPart}.${trimmedDecimal}` : intPart;
}

// 自定义链转换规则
export function transformChain(id: string) {
  const chain = networks.find(network => network.id === Number(id))
  if (!chain) return null
  const chainId = '0x' + Number(id).toString(16)
  return {
    chainId,
    chainName: chain.name,
    rpcUrls: chain.rpcUrls.default.http,
    nativeCurrency: chain.nativeCurrency,
    blockExplorerUrls: chain.blockExplorers?.default.url
  }
}